export function parseProgress(progress = 0) {
  let progressWidth;
  if (progress < 0) {
    progressWidth = 0;
  } else if (progress > 100) {
    progressWidth = 100;
  } else {
    progressWidth = progress;
  }
  return progressWidth;
}
